export const FETCH_COUNTRY = 'FETCH_COUNTRY';
export const FETCH_ALL_COUNTRY = 'FETCH_ALL_COUNTRY';
export const FILTER_COUNTRY = 'FILTER_COUNTRY';